import { ManualReportingScreen } from "types";
import { createScreen } from "utils/createScreen";

const ManualReportingScreenDefinition = createScreen({
  name: ManualReportingScreen,
  path: "/media-activation/manual-reporting",
  routePath: ["/"],
  accessPath: "campaign.manualReporting",
});

export { ManualReportingScreenDefinition };
